import { styled } from "webapp/styled-components";

export const InAppAdContainer = styled.div<{ bgColor: string }>`
    padding: 40px 30px 30px 30px;
    background-color: ${p => p.bgColor};

    border-radius: 12px;
`;

export const ContentContainer = styled.div`
    width: 240px;

    text-align: center;
`;

export const ImageContainer = styled.div<{ url: string }>`
    width: 240px;
    height: 150px;

    background-image: url(${p => p.url});
    background-size: cover;

    margin-bottom: 16px;
`;

export const ModalTitle = styled.div<{ textColor: string }>`
    font-weight: 500;
    font-size: 17px;
    line-height: 22px;

    margin: 0px 12px;

    color: ${p => p.textColor};

    -webkit-line-clamp: 3;
`;

export const DarkTransparentBackground = styled.div`
    width: 100%;
    height: 100%;

    position: absolute;

    display: flex;
    justify-content: center;
    align-items: center;

    background-color: #00000033;
`;

export const ConfirmButton = styled.button<{ textColor: string; buttonColor: string }>`
    height: 44px;
    width: 100%;
    margin-top: 20px;

    color: ${p => p.textColor};

    border-radius: 8px;

    font-weight: 600;
    font-size: 17px;
    line-height: 20px;

    && {
        background-color: ${p => (p.textColor === "#F5F5F5" ? "#4F5DFF" : p.buttonColor)};
    }
`;

export const CancelButton = styled.button<{ textColor: string; color: string }>`
    height: 44px;
    width: 100%;
    margin-top: 16px;

    color: ${p => (p.color === "#F5F5F5" ? "#4F5DFF" : p.textColor)};

    border-radius: 8px;

    font-weight: 600;
    font-size: 17px;
    line-height: 20px;
`;

export const MadeWithGlide = styled.div<{ textColor: string }>`
    color: ${p => p.textColor};
    font-size: 13px;
    line-height: 17px;
    margin-top: 30px;
`;
